import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CfaToolbar } from './toolbar/toolbar';
import { CfaButton } from './buttons/button/button';
import { CfaCartButton } from './buttons/cart-button/cart-button';
import { CfaAppBrandButton } from './buttons/app-brand/app-brand-button';
import { CfaToolbarTabContainer } from './tabs/toolbar-tab-container/toolbar-tab-container';
import { CfaTab } from './tabs/cfa-tab';
import { CfaBottomTabContainer } from './tabs/bottom-tab-container/bottom-tab-container';
import { CfaMenuItem } from './tabs/cfa-menu-item';
import { CfaNavigationWrapper } from './navigation-wrapper/navigation-wrapper';
import { CfaNavContent } from './navigation-wrapper/cfa-nav-content';
import { CfaNavHeader } from './toolbar/cfa-nav-header';
import { RouterModule } from '@angular/router';
import { CfaHamburgerMenu } from './hamburger-menu/hamburger-menu';
import { CfaLoadingModule } from '@emm/core/modules/cfa-loading/cfa-loading-module';
import {SharedModule} from '@emm/shared/shared.module';
import {AvatarComponent} from '@emm/core/modules/cfa-navigation-module/avatar/avatar.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AngularSvgIconModule,
        CfaLoadingModule,
        SharedModule
    ],
    declarations: [
        CfaNavigationWrapper,
        CfaToolbar,
        CfaHamburgerMenu,
        CfaToolbarTabContainer,
        CfaBottomTabContainer,
        CfaNavContent,
        CfaNavHeader,
        CfaTab,
        CfaMenuItem,
        CfaButton,
        CfaAppBrandButton,
        CfaCartButton,
        AvatarComponent
    ],
    exports: [
        CfaNavigationWrapper,
        CfaNavContent,
        CfaHamburgerMenu,
        CfaTab,
        CfaMenuItem,
        CfaBottomTabContainer,
        CfaToolbarTabContainer,
        CfaButton,
        CfaAppBrandButton,
        CfaCartButton,
        CfaNavHeader,
        CfaToolbar,
        AvatarComponent
    ]
})
export class CfaNavigationModule { }
